import { Switch, Route } from "react-router-dom";
import { Redirect } from "react-router";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Home from "./Pages/Industry/Home";
import SavedGame from "./Pages/Industry/SavedGame";
import SelectionFactory from "./Pages/Industry/SelectionFactory";
import MountFactory from "./Pages/Industry/MountFactory";
import Machinery from "./Pages/Industry/Machinery";
import Employees from "./Pages/Industry/Employees";
import MapMenu from "./Pages/Industry/MapMenu";
import FinancialManagement from "./Pages/Industry/FinancialManagement";
import TrainFinancialManagement from "./Pages/Industry/TrainFinancialManagement";

import Production from "./Pages/Industry/Production";
import TrainProduction from "./Pages/Industry/TrainProduction";

import Commercial from "./Pages/Industry/Commercial";
import TrainCommercial from "./Pages/Industry/TrainCommercial";

import LossesAndProfits from "./Pages/Industry/LossesAndProfits";
import Bank from "./Pages/Industry/Bank";
import Consultancy from "./Pages/Industry/Consultancy";
import CashFlow from "./Pages/Industry/CashFlow";

import ToolsPcpSausage from "./Pages/Industry/Pcp/ToolsPcpSausage";
import ToolsPcpChicken from "./Pages/Industry/Pcp/ToolsPcpChicken";
import ToolsPcpCutChicken from "./Pages/Industry/Pcp/ToolsPcpCutChicken";
import ToolsPcpFries from "./Pages/Industry/Pcp/ToolsPcpFries";

import ToolsPurchasePig from "./Pages/Industry/Purchase/ToolsPurchasePig";
import ToolsPurchaseChickenLight from "./Pages/Industry/Purchase/ToolsPurchaseChickenLight";
import ToolsPurchaseChickenHeavy from "./Pages/Industry/Purchase/ToolsPurchaseChickenHeavy";
import ToolsPurchaseFries from "./Pages/Industry/Purchase/ToolsPurchaseFries";
import ToolsPurchaseCarryBag from "./Pages/Industry/Purchase/ToolsPurchaseCarryBag";
import ToolsPurchaseCondiment from "./Pages/Industry/Purchase/ToolsPurchaseCondiment";
import ToolsPurchaseBox from "./Pages/Industry/Purchase/ToolsPurchaseBox";

import ToolsProductionSausage from "./Pages/Industry/ProductionTools/ToolsProductionSausage";
import ToolsProductionChicken from "./Pages/Industry/ProductionTools/ToolsProductionChicken";
import ToolsProductionChickenCut from "./Pages/Industry/ProductionTools/ToolsProductionChickenCut";
import ToolsProductionFries from "./Pages/Industry/ProductionTools/ToolsProductionFries";

import ToolsCommercialSausage from "./Pages/Industry/CommercialSales/ToolsCommercialSausage";
import ToolsCommercialChicken from "./Pages/Industry/CommercialSales/ToolsCommercialChicken";
import ToolsCommercialChickenCut from "./Pages/Industry/CommercialSales/ToolsCommercialChickenCut";
import ToolsCommercialFries from "./Pages/Industry/CommercialSales/ToolsCommercialFries";


import ToolsShippingSausage from "./Pages/Industry/Shipping/ToolsShippingSausage";
import ToolsShippingChicken from "./Pages/Industry/Shipping/ToolsShippingChicken";
import ToolsShippingChickenCut from "./Pages/Industry/Shipping/ToolsShippingChickenCut";
import ToolsShippingFries from "./Pages/Industry/Shipping/ToolsShippingFries";
import ToolsShipping from "./Pages/Industry/Shipping/ToolsShipping";

import WeeklyReportPcp from "./Pages/Industry/WeeklyReport/WeeklyReportPcp";
import WeeklyReportPurchase from "./Pages/Industry/WeeklyReport/WeeklyReportPurchase";
import WeeklyReportProduction from "./Pages/Industry/WeeklyReport/WeeklyReportProduction";
import WeeklyReportCommercial from "./Pages/Industry/WeeklyReport/WeeklyReportCommercial";

import MapMaketplace from "./Pages/Marketplace/MapMaketplace";
import MarketplaceLossesAndProfits from "./Pages/Marketplace/MarketplaceLossesAndProfits";
import MarketplaceCashFlow from "./Pages/Marketplace/MarketplaceCashFlow";
import MpBank from "./Pages/Marketplace/MpBank";
import MpConsultancy from "./Pages/Marketplace/MpConsultancy";

import MpStockChicken from "./Pages/Marketplace/MpStock/MpStockChicken";
import MpStockSausage from "./Pages/Marketplace/MpStock/MpStockSausage";
import MpStockChickenCut from "./Pages/Marketplace/MpStock/MpStockChickenCut";
import MpStockFries from "./Pages/Marketplace/MpStock/MpStockFries";

import MpSalesSausage from "./Pages/Marketplace/MpSales/MpSalesSausage";
import MpSalesChicken from "./Pages/Marketplace/MpSales/MpSalesChicken";
import MpSalesChickenCut from "./Pages/Marketplace/MpSales/MpSalesChickenCut";
import MpSalesFries from "./Pages/Marketplace/MpSales/MpSalesFries";

import WeeklyReportStock from "./Pages/Marketplace/WeeklyReportMp/WeeklyReportStock";
import WeeklyReportPurchases from "./Pages/Marketplace/WeeklyReportMp/WeeklyReportPurchases";
import WeeklyReportSales from "./Pages/Marketplace/WeeklyReportMp/WeeklyReportSales";

import MpPurchasesSausage from "./Pages/Marketplace/MpPurchases/MpPurchasesSausage";
import MpPurchasesChicken from "./Pages/Marketplace/MpPurchases/MpPurchasesChicken";
import MpPurchasesChickenCut from "./Pages/Marketplace/MpPurchases/MpPurchasesChickenCut";
import MpPurchasesFries from "./Pages/Marketplace/MpPurchases/MpPurchasesFries";
import GoogleCallback from "./Pages/GoogleCallback";

const PrivateRoute = (props) => {

  if (localStorage.getItem("@App:user")) {
    return <Route exact path={props.path}>
      {props.children}
    </Route>
  } else {
    return <Redirect to="/" />
  }

}

const Routes = () => {

  return (
    <Switch>
      <Route exact path="/">
        <Login />
      </Route>
      <Route path="/google/callback" >
        <GoogleCallback />
      </Route>
      <PrivateRoute path="/home">
        <Home />
      </PrivateRoute>
      <Route exact path="/register">
        <Register />
      </Route>
      <PrivateRoute exact path="/savedGame">
        <SavedGame />
      </PrivateRoute>
      <PrivateRoute exact path="/selectionFactory">
        <SelectionFactory />
      </PrivateRoute>
      <PrivateRoute exact path="/mountFactory">
        <MountFactory />
      </PrivateRoute>
      <PrivateRoute exact path="/machinery">
        <Machinery />
      </PrivateRoute>
      <PrivateRoute exact path="/employees">
        <Employees />
      </PrivateRoute>
      <PrivateRoute exact path="/mapMenu">
        <MapMenu />
      </PrivateRoute>
      <PrivateRoute exact path="/financialManagement">
        <FinancialManagement />
      </PrivateRoute>
      <PrivateRoute exact path="/trainFinancialManagement">
        <TrainFinancialManagement />
      </PrivateRoute>
      <PrivateRoute exact path="/production">
        <Production />
      </PrivateRoute>
      <PrivateRoute exact path="/trainProduction">
        <TrainProduction />
      </PrivateRoute>
      <PrivateRoute exact path="/commercial">
        <Commercial />
      </PrivateRoute>
      <PrivateRoute exact path="/trainCommercial">
        <TrainCommercial />
      </PrivateRoute>
      <PrivateRoute exact path="/lossesAndProfits">
        <LossesAndProfits />
      </PrivateRoute>
      <PrivateRoute exact path="/bank">
        <Bank />
      </PrivateRoute>
      <PrivateRoute exact path="/cashFlow">
        <CashFlow />
      </PrivateRoute>
      <PrivateRoute exact path="/consultancy">
        <Consultancy />
      </PrivateRoute>

      <PrivateRoute exact path="/toolsPcpSausage">
        <ToolsPcpSausage />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPcpChicken">
        <ToolsPcpChicken />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPcpCutChicken">
        <ToolsPcpCutChicken />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPcpFries">
        <ToolsPcpFries />
      </PrivateRoute>

      <PrivateRoute exact path="/toolsPurchasePig">
        <ToolsPurchasePig />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPurchaseChickenLight">
        <ToolsPurchaseChickenLight />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPurchaseChickenHeavy">
        <ToolsPurchaseChickenHeavy />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPurchaseFries">
        <ToolsPurchaseFries />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPurchaseCarryBag">
        <ToolsPurchaseCarryBag />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPurchaseCondiment">
        <ToolsPurchaseCondiment />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsPurchaseBox">
        <ToolsPurchaseBox />
      </PrivateRoute>

      <PrivateRoute exact path="/toolsProductionSausage">
        <ToolsProductionSausage />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsProductionChicken">
        <ToolsProductionChicken />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsProductionChickenCut">
        <ToolsProductionChickenCut />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsProductionFries">
        <ToolsProductionFries />
      </PrivateRoute>

      <PrivateRoute exact path="/toolsCommercialSausage">
        <ToolsCommercialSausage />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsCommercialChicken">
        <ToolsCommercialChicken />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsCommercialChickenCut">
        <ToolsCommercialChickenCut />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsCommercialFries">
        <ToolsCommercialFries />
      </PrivateRoute>



      <PrivateRoute exact path="/toolsShipping">
        <ToolsShipping />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsShippingSausage">
        <ToolsShippingSausage />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsShippingChicken">
        <ToolsShippingChicken />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsShippingChickenCut">
        <ToolsShippingChickenCut />
      </PrivateRoute>
      <PrivateRoute exact path="/toolsShippingFries">
        <ToolsShippingFries />
      </PrivateRoute>

      <PrivateRoute exact path="/weeklyReportPcp">
        <WeeklyReportPcp />
      </PrivateRoute>
      <PrivateRoute exact path="/weeklyReportPurchase">
        <WeeklyReportPurchase />
      </PrivateRoute>
      <PrivateRoute exact path="/weeklyReportProduction">
        <WeeklyReportProduction />
      </PrivateRoute>
      <PrivateRoute exact path="/weeklyReportCommercial">
        <WeeklyReportCommercial />
      </PrivateRoute>

      <PrivateRoute exact path="/mapMaketplace">
        <MapMaketplace />
      </PrivateRoute>

      <PrivateRoute exact path="/mLossesAndProfits">
        <MarketplaceLossesAndProfits />
      </PrivateRoute>

      <PrivateRoute exact path="/mCashFlow">
        <MarketplaceCashFlow />
      </PrivateRoute>

      <PrivateRoute exact path="/mBank">
        <MpBank />
      </PrivateRoute>

      <PrivateRoute exact path="/mConsultancy">
        <MpConsultancy />
      </PrivateRoute>

      <PrivateRoute exact path="/mpStockChicken">
        <MpStockChicken />
      </PrivateRoute>
      <PrivateRoute exact path="/mpStockSausage">
        <MpStockSausage />
      </PrivateRoute>
      <PrivateRoute exact path="/mpStockChickenCut">
        <MpStockChickenCut />
      </PrivateRoute>
      <PrivateRoute exact path="/mpStockFries">
        <MpStockFries />
      </PrivateRoute>

      <PrivateRoute exact path="/mpSalesSausage">
        <MpSalesSausage />
      </PrivateRoute>
      <PrivateRoute exact path="/mpSalesChicken">
        <MpSalesChicken />
      </PrivateRoute>
      <PrivateRoute exact path="/mpSalesChickenCut">
        <MpSalesChickenCut />
      </PrivateRoute>
      <PrivateRoute exact path="/mpSalesFries">
        <MpSalesFries />
      </PrivateRoute>


      <PrivateRoute exact path="/weeklyReportStock">
        <WeeklyReportStock />
      </PrivateRoute>
      <PrivateRoute exact path="/weeklyReportPurchases">
        <WeeklyReportPurchases />
      </PrivateRoute>
      <PrivateRoute exact path="/weeklyReportSales">
        <WeeklyReportSales />
      </PrivateRoute>


      <PrivateRoute exact path="/mpPurchasesSausage">
        <MpPurchasesSausage />
      </PrivateRoute>
      <PrivateRoute exact path="/mpPurchasesChicken">
        <MpPurchasesChicken />
      </PrivateRoute>
      <PrivateRoute exact path="/mpPurchasesChickenCut">
        <MpPurchasesChickenCut />
      </PrivateRoute>
      <PrivateRoute exact path="/mpPurchasesFries">
        <MpPurchasesFries />
      </PrivateRoute>


      {/* <Route exact path="/purchase">
        <Purchase />
      </Route> */}
      {/* <Route exact path="/purchase">
        <Purchase />
      </Route> */}
      {/* <Route exact path="/purchase">
        <Purchase />
      </Route> */}
      {/* <Route exact path="/purchase">
        <Purchase />
      </Route> */}
      {/* <Route exact path="/purchase">
        <Purchase />
      </Route> */}
      {/* <Route exact path="/purchase">
        <Purchase />
      </Route> */}
      {/* <Route exact path="/purchase">
        <Purchase />
      </Route> */}
    </Switch>
  );
};
export default Routes;
